import React from 'react';
import { connect } from 'react-redux';
import usersActions from '../../store/users/action-creators/index';

const UserTagsManage = (props) => {
  return (
    <div className="list-group list-group-flush tag-list">
      {props.user &&
        props.tags.map((tag, index) => (
          <div
            className="align-items-center d-flex justify-content-between list-group-item"
            key={index.toString()}
          >
            <p>{tag.name}</p>
            {props.user.getHasTag(tag.guid) ? (
              <button
                data-tip="Remove tag"
                className="button default small"
                onClick={() => props.detachUserTag(props.user.guid, tag.guid)}
              >
                <i className="fa fa-times" />
              </button>
            ) : (
              <button
                data-tip="Add tag"
                className="button default small"
                onClick={() => props.attachUserTag(props.user.guid, tag.guid)}
              >
                <i className="fa fa-plus" />
              </button>
            )}
          </div>
        ))}
    </div>
  );
};

// ----------------------
// Redux Mappings
// ----------------------

const mapDispatchToProps = (dispatch) => {
  return {
    attachUserTag: (userGuid, tagGuid) =>
      dispatch(usersActions.attachUserTag(userGuid, tagGuid)),
    detachUserTag: (userGuid, tagGuid) =>
      dispatch(usersActions.detachUserTag(userGuid, tagGuid)),
  };
};

export default connect(null, mapDispatchToProps)(UserTagsManage);
